<div class="flex justify-center mt-[50px]">
  <div class="gamepromo-container">
    <div class="logos-container">
      <div class="slider-container overflow-hidden relative">
        <div class="slider-track flex animate-scroll">
          <div
            class="logo flex-shrink-0 w-full lg:w-1/4 p-2"
            *ngFor="let logo of logos; trackBy: trackByFn"
          >
            <img
              [src]="logo.src"
              [alt]="logo.alt"
              class="w-full h-auto"
              (click)="redirectToSignUp()"
            />
          </div>

          <!-- For a seamless loop -->

          <div
            class="logo flex-shrink-0 w-full lg:w-1/4 p-2"
            *ngFor="let logo of logos; trackBy: trackByFn"
          >
            <img
              [src]="logo.src"
              [alt]="logo.alt"
              class="w-full h-auto"
              (click)="redirectToSignUp()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
